import spinner from './spinner.gif'

const Loader = () => {
    return (
        <div style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "100%",
        }}>
            <img src={spinner} alt="loading" />
        </div>
    )
}

export default Loader
